<template>
  <div class="upload-contain" :style="{ ...classWH }" v-loading="uploadImage">
    <el-upload
      ref="upload"
      v-if="!fileId"
      class="w-full"
      drag
      action="string"
      :http-request="importListFile"
      :accept="accept"
      :show-file-list="false"
      :auto-upload="false"
      :multiple="false"
      :limit="1"
      :on-change="onChange"
      :disabled="isDisabledUploadComponent"
    >
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">
        <em>点击上传</em>
      </div>
    </el-upload>
    <div class="w-full h-full upload-demo-list" v-else>
      <img class="w-full h-full border border-gray-500/20 object-contain" :src="imgContent" alt="" />
      <div class="w-full h-full demo-upload-list-cover">
        <span class="absolute">
          <el-upload
            ref="reupload"
            class="w-0 hidden"
            drag
            action="string"
            :http-request="importListFile2"
            :accept="accept"
            :show-file-list="false"
            :auto-upload="false"
            :multiple="false"
            :on-change="reUploadoOnChange"
            :disabled="isDisabledUploadComponent"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              <em>点击上传</em>
            </div>
          </el-upload>
          <i class="el-icon-view text-base" v-if="showPreview" @click="handlePreview"></i>
          <i class="el-icon-upload2 text-base" v-if="isShowUpdate" @click="handleUpdate"></i>
          <i class="el-icon-delete text-base ml-8px" v-if="isShowDeleteButton" @click="handleDel"></i>
        </span>
      </div>
    </div>

    <el-dialog :visible.sync="dialogVisible" append-to-body>
      <img :src="imgContent" class="w-full h-full object-contain" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import { FileApi } from '@wiz-api/file-management'

const fileApi = new FileApi()
export default {
  name: 'ImgUpload',
  props: {
    // 文件id
    fileId: {
      type: String,
      default: '',
    },
    showPreview: {
      type: Boolean,
      default: false,
    },
    // 图片格式
    accept: {
      type: String,
      default: 'jpg,jpeg,png,JPG,JPEG,',
    },
    // 限制图片尺寸宽高，例如： [375, 240]
    limitImgWHArr: {
      type: Array,
      default: () => {
        return [375, 240]
      },
    },
    // 限制图片大小,以M为单位
    maxSize: {
      type: Number,
      default: 3,
    },
    // 长度
    uploadWidth: {
      type: Number,
      default: 120,
    },
    // 高度
    uploadHeight: {
      type: Number,
      default: 120,
    },
    // 现在文件格式
    limit: {
      type: Boolean,
      default: false,
    },
    // 上传组件提示文本
    toolTipText: {
      type: String,
      default: '',
    },
    // 是否显示删除按钮
    isShowDeleteButton: {
      type: Boolean,
      default: true,
    },
    // 是否显示重新上传按钮
    isShowUpdate: {
      type: Boolean,
      default: false,
    },
    // 判断多组件
    faviocon: {
      type: String,
      default: 'upload',
    },
    // 是否禁用上传组件
    isDisabledUploadComponent: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // 图片预览信息
      imgContent: null,
      // 预览弹窗
      dialogVisible: false,
      uploadImage: false
    }
  },
  computed: {
    classWH() {
      return {
        width: `${this.uploadWidth}px`,
        height: `${this.uploadHeight}px`,
      }
    },
    fileUrl() {
      const fileServer = Wiz.GetModuleServer('file-management')
      return `${fileServer}/api/file-management/files/public/image/`
    },
  },
  created() {
    if (this.fileId) {
      this.getImgContent(this.fileId)
    }
  },
  methods: {
    // 图片上传覆盖方法
    importListFile(params) {
      // 图片上传大小
      if (params.file.size / 1024 / 1024 > this.maxSize) {
        this.$message.warning(`图片上传最大不能超过${this.maxSize}M`)
        this.$refs.upload.clearFiles()
        return
      }
      // 图片上传格式
      if (
        this.accept.indexOf(params.file.name.split('.').slice(-1)[0]) === -1 &&
        this.limit &&
        params.file.name
      ) {
        this.$emit('tips')
        return
      }
      this.imgUpload1(params)
    },
    // 图片上传覆盖方法
    importListFile2(params) {
      // 图片上传大小
      if (params.file.size / 1024 / 1024 > this.maxSize) {
        this.$message.warning(`图片上传最大不能超过${this.maxSize}M`)
        this.$refs.reupload.clearFiles()
        return
      }
      // 图片上传格式
      if (
        this.accept.indexOf(params.file.name.split('.').slice(-1)[0]) === -1 &&
        this.limit &&
        params.file.name
      ) {
        this.$emit('tips')
        return
      }
      this.imgUpload(params)
    },
    /**
     * 图片上传请求
     */
    async imgUpload(params) {
      const [err, res] = await fileApi.upload({
        files: [params.file],
        authLevel: 2,
      })
      if (!err) {
        res.forEach((item) => {
          this.$emit('update:fileId', item)
          this.getImgContent(item.id)
        })
      }
    },
    /**
     * 图片上传请求
     */
    async imgUpload1(params) {
      const [err, res] = await fileApi.upload({
        files: [params.file],
        authLevel: 2,
      })
      if (!err) {
        res.forEach((item) => {
          this.$emit('update:fileId', item)
          this.getImgContent(item.id)
        })
        this.$refs.upload.clearFiles()
      }
    },

    /**
     * 获取图片内容并进行预览
     * @param {*} fileId 文件id
     */
    async getImgContent(fileId) {
      this.imgContent = `${this.fileUrl}${fileId}`
      // 获取图片内容
      // const [error, result] = await fileApi.getPublicImageBaseString(fileId)
      // if (!error) {
      //   this.imgContent = `data:image/png;base64,${result.base64}`
      // }
    },
    onChange(file, fileList) {
      this.$refs.upload.submit()
    },
    reUploadoOnChange() {
      this.$refs.reupload.submit()
    },
    // 预览
    handlePreview() {
      this.dialogVisible = true
      this.$emit('view')
    },
    // 删除
    async handleDel() {
      this.$confirm('是否删除', '提示', {
        confirmButtonText: '确定',
        cancelButtontext: '取消',
        closeOnClickModal: false,
        type: 'warning',
      }).then(() => {
        this.imgContent = null
        this.$emit('delete', this.fileId)
      })
    },
    // 更新
    handleUpdate() {
      this.$emit('reUpload', this.fileId)
      this.$refs.reupload.$children[0].$el.click()
    },
  },
}
</script>

<style lang="scss" scoped>
.upload-contain {
  position: relative;

  .demo-upload-list-cover {
    position: absolute;
    inset: 0;
    display: none;
    background: rgba(0, 0, 0, 0.6);

    & i {
      color: #fff;
    }
  }
}

.upload-contain:hover {
  .demo-upload-list-cover {
    display: block;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
}
// /deep/.el-icon-upload {
//   margin: 26px 0 16px !important;
// }
</style>
